"use strict";

define('evisions/helper/string',['underscore'], function (_) {
  var EVIHelperString = _.extend({
    camelCase: function camelCase(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    camelCaseFromNamespace: function camelCaseFromNamespace(str) {
      str = str.split('.');
      for (var i = 0; i < str.length; i++) {
        str[i] = eviHelperString.camelCase(str[i]);
      }
      return str.join('');
    },
    formatNumber: function formatNumber(num) {
      var sections = String(num).split('.'),
        number = sections[0] || '0',
        decimal = sections[1] || '',
        strArr = number.split('').reverse(),
        arr = [],
        finalStr = '';
      if (number.length <= 3) {
        return String(num);
      }
      while (strArr.length) {
        arr.push(strArr.splice(0, 3).reverse().join(''));
      }
      finalStr = arr.reverse().join(',');
      if (decimal) {
        finalStr += '.' + decimal;
      }
      return finalStr;
    },
    toLowerCase: function toLowerCase(str) {
      return String(str).toLowerCase();
    },
    toProperCase: function toProperCase(str) {
      return String(str).replace(/\w\S*/g, function (word) {
        return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
      });
    },
    unescapeHTML: function unescapeHTML(string) {
      return $('<div/>').html(string).text();
    }
  });
  return EVIHelperString;
});

